export const LocalStorageEventName = {
  language: 'language', //多语言设置
  deviceLanguage: 'deviceLanguage', //手机语言设置
  region: 'region' //地区
};
